<template>
  <div class="stats_prof">
    <p class="numb">{{ value }}</p>

    <p class="txt">{{ $_translations.value[description] }}</p>
  </div>
</template>

<script setup>
defineProps({
  value: {
    type: [Number, String],
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
});
</script>
